module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmsdetail"
  }, [_c('div', {
    staticClass: "wx_warn"
  }, [_c('p', {
    staticClass: "wx_left"
  }, [_vm._v("\n      请您及时付款，以便订单尽快处理！订单号\n      "), _c('span', [_vm._v(_vm._s(_vm.order_code))])]), _vm._v(" "), _c('p', {
    staticClass: "wx_right"
  }, [_vm._v("\n      应付金额\n      "), _c('span', {
    staticStyle: {
      "color": "#ff6401",
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.price / 100))]), _vm._v("元\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "wx_con"
  }, [_c('div', {
    staticClass: "wx_con_top"
  }, [_c('p', {
    staticClass: "wx_p"
  }, [_vm._v("微信支付")]), _vm._v(" "), _c('div', {
    staticClass: "top_mid"
  }, [_c('p', {
    staticClass: "mid_p"
  }, [_vm._v("二维码有效时长为2小时，请尽快支付")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.pic_url,
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    staticClass: "wx_img",
    attrs: {
      "src": "https://www.meijiexia.cn/statics/cashier/wx_2.gif"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "payid",
      "value": "DF202011270940423475"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mid_bottom",
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.meijiexia.cn/statics/cashier/wx_1.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n            请使用微信扫一扫\n            "), _c('br'), _vm._v("扫描二维码支付\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cb52959","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/order/WeixinPay.vue
// module id = 1208
// module chunks = 0